export default import.meta.ROLLDOWN_FILE_URL_NEPcWJBT$kZEeeg6IT4dYw